export const SUBSCRIPTION = 'subscription'
export const SET_AVAILABLE_SUBSCRIPTIONS_LIST = SUBSCRIPTION + '/SET_AVAILABLE_SUBSCRIPTIONS_LIST'